export const SectionHeroTranslationsEn = {
  'Platform Description':
    'platform for renting upscale clothing and goods for children and families',
  rent: 'rent',
};
